import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    headerTitle: translate({ id: 'settings.gpsFormats.edit.header.title' }),
    headerDescription: translate({ id: 'settings.gpsFormats.edit.header.description' }),
  }))

  return api
}
